import { render, staticRenderFns } from "./DeleteKnowledgeUnitExceptionDialog.vue?vue&type=template&id=2c73e153&"
import script from "./DeleteKnowledgeUnitExceptionDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteKnowledgeUnitExceptionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports